/*
  Что человеку можно делать ПРЯМО СЕЙЧАС (аудит 26.10.2026, причина 2).

  Сервер отказывает в действии дважды: роли без права и организации с неоплаченной
  лицензией (`Principal.require`, режим «только чтение», §3.1.6). Кабинет знал только
  про первое: кнопки стояли на месте, и каждое нажатие кончалось отказом «Лицензия не
  оплачена».

  Правило не повторяется здесь: профиль несёт готовый перечень `actions` (то, что из
  прав роли разрешено сейчас), а `permissions` остаются перечнем того, что ВИДНО.
  Второй расчёт на клиенте разошёлся бы с серверным при первой правке перечня действий
  (`backend/app/core/access.py`, `WRITING_PERMISSIONS`).
*/

/** Право есть у роли - достаточно, чтобы раздел был ВИДЕН (меню, данные). */
export function has(profile, permission) {
  return Boolean(profile?.permissions?.includes(permission))
}

/** Действие разрешено сейчас: при «только чтение» запись закрыта даже у роли с правом. */
export function can(profile, permission) {
  // Профиль без перечня действий (старый сервер, чужие тесты) читается как «можно всё,
  // что дано роли»: лишняя кнопка хуже прежнего поведения не станет, сервер откажет сам.
  const allowed = profile?.actions ?? profile?.permissions
  return Boolean(allowed?.includes(permission))
}

/*
  Сборка документов (строка 127 реестра, 30.10.2026): заявление, уведомление, иск,
  индексация. Это не отдельное право роли, а `build_documents` плюс ярус участия: на
  полном обслуживании («Под ключ») документы готовит платформа, и сотрудник заказчика их
  собрать не может, а агент сопровождения - может. Профиль несёт готовое действие
  `assemble_documents` (`schemas/auth.py`), как и остальной перечень `actions`.
*/
export function canAssemble(profile) {
  // Профиль без перечня действий читается как «можно всё, что дано роли» (см. `can`).
  if (!profile?.actions) return has(profile, 'build_documents')
  return profile.actions.includes('assemble_documents')
}

/** Сборка закрыта именно ярусом: право роли и лицензия в порядке, а действия нет. */
export function assemblyClosedByTier(profile) {
  return has(profile, 'build_documents') && can(profile, 'build_documents') && !canAssemble(profile)
}

/** Сборка документов одним значением для экранов: можно ли и закрыта ли именно ярусом. */
export function assemblyOf(profile) {
  return { allowed: canAssemble(profile), closedByTier: assemblyClosedByTier(profile) }
}
